class CodeltyCollectionNav extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.codelty-collection-nav__list');
    this.prevBtn = this.querySelector('[data-collection-nav-prev]');
    this.nextBtn = this.querySelector('[data-collection-nav-next]');
    if (!this.list) return;

    this.onResize = this.updateMode.bind(this);
    this.onScroll = this.syncArrows.bind(this);

    this.prevBtn?.addEventListener('click', () => this.scrollByStep(-1));
    this.nextBtn?.addEventListener('click', () => this.scrollByStep(1));

    this.list.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.updateMode());
      this.resizeObserver.observe(this.list);
    }

    this.updateMode();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.list?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  listWraps() {
    const items = this.list.querySelectorAll('.codelty-collection-nav__item');
    if (items.length < 2) return false;

    const firstTop = items[0].offsetTop;
    const lastTop = items[items.length - 1].offsetTop;
    return lastTop > firstTop + 1;
  }

  updateMode() {
    this.classList.remove('codelty-collection-nav--carousel');
    const shouldCarousel = this.listWraps();
    this.classList.toggle('codelty-collection-nav--carousel', shouldCarousel);

    if (shouldCarousel) {
      requestAnimationFrame(() => {
        this.scrollActiveIntoView(false);
        this.syncArrows();
      });
    } else {
      this.prevBtn?.setAttribute('disabled', '');
      this.nextBtn?.setAttribute('disabled', '');
    }
  }

  getStep() {
    const item = this.list.querySelector('.codelty-collection-nav__item');
    if (!item) return 0;
    const gap = parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap) || 24;
    return item.getBoundingClientRect().width + gap;
  }

  scrollByStep(direction) {
    const step = this.getStep();
    if (!step) return;

    this.list.scrollBy({
      left: step * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  scrollActiveIntoView(smooth) {
    const active = this.list.querySelector('.codelty-collection-nav__link--active');
    if (!active) return;

    active.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      block: 'nearest',
      inline: 'center',
    });
  }

  syncArrows() {
    if (!this.classList.contains('codelty-collection-nav--carousel')) return;

    const max = this.list.scrollWidth - this.list.clientWidth - 2;
    this.prevBtn?.toggleAttribute('disabled', this.list.scrollLeft <= 2);
    this.nextBtn?.toggleAttribute('disabled', this.list.scrollLeft >= max);
  }
}

if (!customElements.get('codelty-collection-nav')) {
  customElements.define('codelty-collection-nav', CodeltyCollectionNav);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('codelty-collection-nav').forEach((nav) => {
    if (typeof nav.updateMode === 'function') nav.updateMode();
  });
});
